import PropTypes from 'prop-types';
import React from 'react';
import get from 'lodash/get';

import { GenericContext } from 'shared/constants';

import { renderValue } from './functions';

function CustomField(props) {
  const {
    settings: {
      dateFormats: { dateFormat },
    },
  } = React.useContext(GenericContext);

  const { jsonSchema, uiSchema, customFields, jsonSchemaKey, inlineMode, previewMode, showDescription } = props;

  const schemaProperty = get(jsonSchema, `properties.${jsonSchemaKey}`, {});
  const value = customFields[jsonSchemaKey];
  const valueIsArray = Array.isArray(value);
  const arrayValuesMode = valueIsArray && value.every((item) => item && typeof item === 'object');
  const objectMode =
    (value && typeof value === 'object' && !valueIsArray) ||
    (!arrayValuesMode && valueIsArray && value.find((item) => typeof item === 'object'));

  const showInline = inlineMode && !objectMode;

  const renderOptions = {
    dateFormat,
    schemaProperty,
    previewMode,
    showInline,
    uiSchema,
    jsonSchemaKey,
  };

  const renderLabel = (isShowLabel = true) => {
    if (!isShowLabel) {
      return;
    }

    return <label className="control-label">{schemaProperty.title || jsonSchemaKey}</label>;
  };

  const content = showInline ? (
    <>
      {renderLabel(props.isShowLabel)}
      <span className="formatted-text">{renderValue(value, renderOptions)}</span>
      {showDescription && schemaProperty.description && (
        <p className="field-description">{schemaProperty.description}</p>
      )}
    </>
  ) : (
    <>
      {renderLabel(props.isShowLabel)}
      {showDescription && schemaProperty.description && (
        <p className="field-description">{schemaProperty.description}</p>
      )}
      <div className="formatted-text">
        {objectMode && <span className="text-danger">{JSON.stringify(value, null, 2)}</span>}
        {!objectMode && renderValue(value, renderOptions)}
      </div>
    </>
  );

  return (
    <div key={jsonSchemaKey} className={schemaProperty.type === 'null' ? 'field-null' : 'form-group'}>
      {content}
    </div>
  );
}

CustomField.contextTypes = {
  settings: PropTypes.object.isRequired,
};

CustomField.propTypes = {
  jsonSchema: PropTypes.object.isRequired,
  uiSchema: PropTypes.object.isRequired,
  customFields: PropTypes.object.isRequired,
  jsonSchemaKey: PropTypes.string.isRequired,
  previewMode: PropTypes.bool,
  inlineMode: PropTypes.bool,
  showDescription: PropTypes.bool,
  isShowLabel: PropTypes.bool,
};

// eslint-disable-next-line import/no-default-export
export default CustomField;
